<template>
    <form-wizard
        color="#7367f0"
        :title="null"
        :subtitle="null"
        finish-button-text="Сохранить"
        next-button-text="Далее"
        back-button-text="Назад"
        class="steps-transparent"
        @on-complete="() => submitAction()"
    >
        <tab-content
                icon="feather icon-file-text"
                title="Данные для входа"
                :before-change="()=> validateForm(steps['step_1'].value)"
        >
            <validation-observer
                    ref="step_1"
                    tag="form"
            >
                <b-form-group
                    label="Email"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите email пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="email"
                            rules="required|email"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['email']"
                                @input="(val) => formModel['username'] = val"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group>
                    <b-form-checkbox v-model="useEmailAsNickname">
                      Использовать email в качестве никнейма пользователя
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group
                    label="Никнейм"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите ник для пользователя, он понадобится для входа в аккаунт. Можете использовать email в качестве никнейма "
                    v-if="!useEmailAsNickname"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="username"
                            rules="required"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['username']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Общие данные"
                :before-change="()=> validateForm(steps['step_2'].value)"
        >
            <validation-observer
                    ref="step_2"
                    tag="form"
            >
                <b-form-group
                    label="Имя"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите имя пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="first_name"
                            rules="required"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['first_name']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Фамилия"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите фамилию пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="last_name"
                            rules="required"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['last_name']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Должность"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите должность пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="job_title"
                            rules="required"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['worker']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
    </form-wizard>
</template>


<script>
    import {ref} from '@vue/composition-api'

    import {BContainer, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import { STORE_MODULE_NAME } from '@/views/apps/user/userStoreModule'
    import useUser from '@/views/apps/user/useUser'

    import { validateForm } from '@core/utils/validations/utils'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required, email } from '@validations'


    import useAppElementListAddNew from "@core/components/app-elements/appElementListAddNew/useAppElementListAddNew";


    export default {

        components:{
            BContainer, BRow, BCol,
            FormWizard, TabContent,
            BForm, BFormGroup, BFormInput, BFormCheckbox,

            ValidationProvider, ValidationObserver
        },

        setup() {

            const {
                addDataUrl,
                updateDataUrl,
                setupData,
            } = useUser();

            const {
                formModel,
                submitAction,
            } = useAppElementListAddNew({
                storeModuleName: STORE_MODULE_NAME,
                addDataUrl: addDataUrl,
                updateDataUrl:updateDataUrl,
                ...setupData,
            })


            const steps = {
                step_1:ref(null),
                step_2:ref(null),
            }

            const useEmailAsNickname = ref(true)


            return {
                submitAction,
                formModel,

                steps, ...steps,
                validateForm,
                useEmailAsNickname
            }
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
</style>
